const COOKIEBOT_EVENTS = [
  "CookiebotOnConsentReady",
  "CookiebotOnAccept",
  "CookiebotOnDecline",
];

export default function () {
  let lastSent = null;

  const sendConsent = () => {
    const cookiebot = window.Cookiebot;
    if (typeof window.bp !== "function" || !cookiebot?.hasResponse) {
      return;
    }

    const consent = cookiebot.consent?.marketing
      ? "grantConsent"
      : "rejectConsent";
    if (consent === lastSent) {
      return;
    }

    lastSent = consent;
    window.bp("consent", consent);
  };

  COOKIEBOT_EVENTS.forEach((event) =>
    window.addEventListener(event, sendConsent)
  );
  sendConsent();
}
